export function renderLLMThreadCreateFields() {
  return `
    <div class="form-note">This thread will use the direct inference backend and retained chat history.</div>
    <div class="form-note">Follow-up turns stay lightweight and do not require a workspace checkout.</div>
  `;
}
